export enum SSEEventType {
    CHAT = 'chat:new-message',
    CHAT_ATTACHMENT_UNLOCKED = 'chat:attachment-unlocked',
    CHAT_PAID_MESSAGE_UNLOCKED = 'chat:paid-message-unlocked',
    CHAT_MESSAGE_DELETED = 'chat:message-deleted',
    BROADCAST = 'broadcast:new-message',
    GROUP = 'group:new-message',
    NOTIFICATION = 'notification',
    GOAL_DONATE = 'goal:donate',
    PAID_CONNECTION_MESSAGE = 'chat:paid-connection-message'
}
